import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const mainContent: SxStyleFunc<boolean | undefined> = (mdDown) => ({
  minWidth: mdDown ? 'unset' : ' 700px',
});

export const headerIcon: SxStyle = {
  color: (p) => p.palette.grey[700],
  cursor: 'pointer',
};

export const headerTitle: SxStyle = {
  fontSize: (p) => p.typography.body1.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
  color: (p) => p.palette.grey[700],
};

export const dialogHeader: SxStyle = {
  background: (p) => p.palette.primary[50],
  borderBottomColor: (p) => p.palette.primary[100],
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  px: 2,
  py: 1.5,
  // width: ' 737px',
};

export const header: SxStyle = {
  p: (p) => p.spacing(2),
  color: (p) => p.palette.grey[700],
  background: (p) => p.palette.primary[50],
  borderBottomWidth: '1px',
  borderBottomColor: (p) => p.palette.primary[100],
  borderBottomStyle: 'solid',
  fontSize: (p) => p.typography.body1.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
};
